export class LoadIuguAccountAction {
  static readonly type = '[iugu-account] Load IUGU Account';

  constructor() { }
}